export const TOKENS = {
  ASETQU: { symbol: 'ASETQU', decimals: 18 },
  USDI: { symbol: 'USDI', decimals: 18 },
} as const;

export type TokenKey = keyof typeof TOKENS;

export const INDODAX_WS_URL = 'wss://ws3.indodax.com/ws/';
export const INDODAX_TOKEN = import.meta.env.VITE_INDODAX_TOKEN;
if (!INDODAX_TOKEN) {
  throw new Error('INDODAX_TOKEN is not defined');
}
